export interface WeightedValue {
  weight: number;
  value: number;
}

export const getWeightedAverage = (data: WeightedValue[]) => {
  // Calculates the sum of the product of each data point's value and its weight.
  const sumOfMultiplied = data
    .map(item => item.weight * item.value)
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

  // Calculates the sum of the weights of all data points.
  const sumOfWeights = data
    .map(item => item.weight)
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

  // If either sum is zero, returns zero, otherwise computes and returns the weighted average.
  if (sumOfMultiplied === 0 || sumOfWeights === 0) {
    return 0;
  }
  return sumOfMultiplied / sumOfWeights;
};
